import React, { Component } from "react";
import lottie from "lottie-web";
import MatchDraw from "./MatchDraw";
import CountdownTimer from "./CountdownTimer";
import { Utils } from "../../utils/Utils";
import { ReplayAction } from "./ReplayActionBuilder";
import utils from '../../lib/utils';

window.actionID;

// let rangeSize = 50; //感应范围容错大小，越大越容易拖进框内

/**
 * 该模板需要支持，单图匹配、多图匹配、音图匹配
 * cid=1_1_1&page=28    单图匹配
 * cid=1_1_1&page=32    多图匹配
 * cid=1_2_1&page=29    音图匹配
 * cid=1_2_6&page=23    拼图
 * cid=2_6_1&page=5，cid=2_11_1&page=11     done - MutiMatchGameWithDoneInteraction_
 */

class MatchGame extends Component {
    constructor(props) {
        super(props);
        this.state = {
            darwObj: null,
            drawRightTotal: 0, //  拖对位置的总数量
            drawTotal: 0, //  拖的总数量，错误的也算
            start_top: 0,
            start_left: 0,
            currStarCount: 0, //当前的星星数
            currSubjectCount: 0, //当前题目数（有starSubject=1的时候就加1）
            playNum: 0, //当前播放音频的序号
            autoDisTipsDraw: "", //小朋友在pc上拖拽不方便，支持点击，默认按顺序在正确位置显示一个框，存放 dstobjs 下的 id，如：GAME_DST_1
            canMatch: true,
            matchDoneElements: [],   //存放每个位置信息，done用，因为可以拖到错的位置，支持在拖下来
            dragAnswers: [],   //存放每个位置信息是否已经拖放元素进来，done用。-1：默认；0-错误；1-正确
            dragAnswerDsts: [],   //存放每个位置的位置名称
            restoreOption: -1,  //done模板拖错以后点done，1-错误弹回；2-全部弹回；3-正确答案
            retryTimes: props.item && props.item.detail && props.item.detail.retryTimes ? props.item.detail.retryTimes : 0,  //重试次数
            doneTryData: null,
        };
        this.cid = Utils.getHashQueryString("cid");
        this.putaoid = Utils.getCookie('putaoid') || 0;
        this.token = Utils.getCookie('token');
        this.uuid = Utils.getCookie('uuid') || 0;
        this.drawTotal = 0;
        this.autoPlayList = [];
        this.curDrawRightNum = -1; //拖对项的序号
        this.curDrawRightArr = []; //拖对项的集合
        this.guideTimer = null;
        this.replayKeyNum = 2; //录屏的key，默认有一个 begin和feedback，因此默认是2，每次调用一下ReplayAction.add，就加1
        this.isDone = (props.item && props.item.actionType && props.item.actionType === "MutiMatchGameWithDoneInteraction_") ? true : false; //是否需要点Done提交答案，这种类型的拖上去以后可以再拖下来
        this.doneIntervalTimer = null;
        this.roundNum = 1;  // 第几轮
        this.startWorkTime = new Date().getTime();  // 开始时间，用来计算完成这个模板使用的时间，用于算给积分
        this.isOver = false;    // 是否已完成
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            currStarCount: nextProps.currStarCount,
            currSubjectCount: nextProps.currSubjectCount,
            doneTryData: nextProps.doneTryData,
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const that = this;
        const { doneTryData } = this.state;
        // if (window.doneTryData && window.doneTryData.retryTimes !== prevState.retryTimes) {
        //     if (window.doneTryData.needMatch) {
        //         that.setState({
        //             canMatch: true,
        //             retryTimes: window.doneTryData.retryTimes
        //         });
        //     } else {
        //         that.setState({
        //             restoreOption: window.doneTryData.restoreOption,
        //         });
        //     }
        //     window.doneTryData = null;
        // }
        if (doneTryData && doneTryData.retryTimes !== prevState.retryTimes) {
            that.isOver = false;
            if (doneTryData.needMatch) {
                that.setState({
                    canMatch: true,
                    retryTimes: doneTryData.retryTimes,
                    doneTryData: null
                });
            } else {
                that.setState({
                    restoreOption: doneTryData.restoreOption,
                    doneTryData: null
                });
            }
        }

        let drawCircle = document.getElementsByClassName('draw-circle');
        if (drawCircle && drawCircle.length > 0) {
            for (let i = 0; i < drawCircle.length; i++) {
                if (drawCircle[i] && drawCircle[i].parentNode) {
                    drawCircle[i].parentNode.removeChild(drawCircle[i]);
                }
            }
        }
    }

    /**
     * srcObjs：存放可拖动的元素原始的位置、大小信息
     * matchRules：存放每个答案区的匹配范围和正确位置
     * dstObjs：存放正确位置信息，里面的 dst === dstObj.id 就是拖动元素的正确位置
     */
    componentDidMount() {
        const that = this;
        const { item } = this.props;
        const { dragAnswers } = this.state;

        //整合match各项的大小和位置
        let newDarwObj = {};
        let matchDoneElements = [];
        if (item.detail.srcObjs) {
            that.drawTotal = item.detail.srcObjs.length;
            item.detail.srcObjs.forEach((srcObj, srcIndex) => {
                let eleDom = document.getElementById(srcObj.id);
                if (eleDom) {
                    if (!newDarwObj[srcObj.id]) {
                        newDarwObj[srcObj.id] = {};
                    }

                    newDarwObj[srcObj.id]["bigImage"] = srcObj.bigImage;
                    newDarwObj[srcObj.id]["defaultPos"] = {
                        //起始位置
                        x: that.isDone && srcObj.pos ? srcObj.pos.x * window.mainSize.width : eleDom.offsetLeft,
                        y: that.isDone && srcObj.pos ? srcObj.pos.y * window.mainSize.height : eleDom.offsetTop
                    };
                    newDarwObj[srcObj.id]["defaultWidth"] = {
                        //默认展示的大小，这个是除2以后的值
                        width: parseInt(eleDom.style.width, 10),
                        height: parseInt(eleDom.style.height, 10)
                    };

                    //移除ShowPic_的图片
                    setTimeout(() => {
                        if (eleDom && eleDom.parentNode) {
                            eleDom.parentNode.removeChild(eleDom);
                        }
                    }, 100);
                }

                item.detail.matchRules.forEach(matchRule => {
                    if (srcObj.id === matchRule.src) {
                        let dst = matchRule.dst;
                        item.detail.dstObjs.forEach(dstObj => {
                            if (!newDarwObj[srcObj.id]["pos"]) {
                                //存放匹配的正确位置x，y，可能有多个匹配，所以用数组
                                newDarwObj[srcObj.id]["pos"] = [];
                            }
                            if (!newDarwObj[srcObj.id]["matchPos"]) {
                                //存放匹配的范围位置x，y，可能有多个匹配，所以用数组
                                newDarwObj[srcObj.id]["matchPos"] = [];
                            }
                            if (!newDarwObj[srcObj.id]["gameDst"]) {
                                //存放匹配的正确位置名称
                                newDarwObj[srcObj.id]["gameDst"] = [];
                            }
                            if (dst === dstObj.id) {
                                let dstObjSize = {
                                    width: dstObj.size ? dstObj.size.width * window.mainSize.percent : 0,
                                    height: dstObj.size ? dstObj.size.height * window.mainSize.percent : 0
                                };
                                let matchRangeSize = {
                                    width: dstObj.matchRange ? dstObj.matchRange.size.width * window.mainSize.percent : 0,
                                    height: dstObj.matchRange ? dstObj.matchRange.size.height * window.mainSize.percent : 0
                                };
                                newDarwObj[srcObj.id]["bigImageSize"] = dstObjSize; //拖动后的原图大小
                                newDarwObj[srcObj.id]["matchSize"] = dstObj.matchRange ? matchRangeSize : dstObjSize; //匹配区大小
                                newDarwObj[srcObj.id]["matchPos"].push(dstObj.matchRange ? dstObj.matchRange.pos : dstObj.pos); //正确匹配范围
                                newDarwObj[srcObj.id]["pos"].push(dstObj.pos); //正确位置
                                newDarwObj[srcObj.id]["gameDst"].push(dstObj.id);
                                dragAnswers[srcIndex] = -1; //默认位置没有答案
                            }
                            if (!that.curDrawRightArr.includes(dstObj.id)) {
                                that.curDrawRightArr.push(dstObj.id);
                            }
                        });
                    }
                });

                //音频匹配
                if (item.actionType === "AudioMutiMatchGameInteraction_") {
                    newDarwObj[srcObj.id]["audio"] = srcObj.audio;
                    newDarwObj[srcObj.id]["playBottom"] = srcObj.playBottom;
                    newDarwObj[srcObj.id]["headPhone"] = srcObj.headPhone;
                    that.autoPlayList.push({
                        id: srcObj.headPhone,
                        audio: srcObj.audio
                    });
                    document.getElementById(srcObj.headPhone).setAttribute("class", "playBottom");
                    document.getElementById(srcObj.headPhone).setAttribute("audionum", srcIndex);
                    document.getElementById(srcObj.playBottom).setAttribute("class", "playBottom");
                    document.getElementById(srcObj.playBottom).setAttribute("audionum", srcIndex);
                }

                // if (that.isDone) {
                if (item.detail.dstObjs[srcIndex]) {
                    matchDoneElements.push({
                        matchRange: item.detail.dstObjs[srcIndex].matchRange ? item.detail.dstObjs[srcIndex].matchRange.pos : item.detail.dstObjs[srcIndex].pos,
                        pos: item.detail.dstObjs[srcIndex].pos,
                        gameDst: item.detail.dstObjs[srcIndex].id
                    });
                } else {
                    matchDoneElements.push({
                        gameDst: `noDst${srcIndex}`
                    });
                }
                // }

                if (dragAnswers[srcIndex] !== -1) {
                    dragAnswers[srcIndex] = -1;//1;  //拖的项多于正确项，因此把多出来的拖拽项直接默认是正确的
                }
            });
            // console.log(matchDoneElements);
            // console.log(dragAnswers)
            console.log(newDarwObj)

            that.setState({
                darwObj: newDarwObj,
                autoDisTipsDraw: item.detail.dstObjs[0].id,
                matchDoneElements: matchDoneElements,
                dragAnswers: dragAnswers
            }, () => {
                if (item.actionType === "AudioMutiMatchGameInteraction_") {
                    that.playAudio(0);

                    let playBottom = document.getElementsByClassName("playBottom");
                    for (let i = 0; i < playBottom.length; i++) {
                        playBottom[i].addEventListener("click", () => {
                            let content = document.getElementById("content");
                            if (
                                that.state.drawRightTotal !== item.detail.dstObjs.length &&
                                (content.className === "content toCenter" || content.className === "content fullScreen")
                            ) {
                                let _num = playBottom[i].getAttribute("audionum");
                                that.playAudio(_num, true);

                                //录屏相关代码
                                if (window.needRecoRecordCourse) {
                                    ReplayAction.add(window.keyStr, "AUDIOMATCH_REPLAY_TAP", new Date().getTime() - window.recordPageTime, JSON.stringify({ index: _num }));
                                    that.replayKeyNum++;
                                }
                            }
                        }, false);
                    }
                }

                //录屏相关代码
                if (window.needRecoRecordCourse) {
                    if (!(window.g_currentScene && window.g_currentScene.timeline)) {
                        ReplayAction.setScene(JSON.stringify(window.curPageSceneList));
                    }
                    ReplayAction.add(window.keyStr, that.isDone ? "MATCH_REPLAY_BEGIN" : "MATCH_REPLAY_BEGIN", new Date().getTime() - window.recordPageTime, JSON.stringify({ count: 60 }));
                }
            });

            //新用户指引
            that.guideTimer = setTimeout(() => {
                let subActionType = item.subActionType;
                let localSubActionType = window.localStorage.getItem(subActionType);
                let _id = item.detail.srcObjs[0].bigImage;
                let firstImg = document.getElementById(_id);
                let content_course = document.getElementById("content_course");
                let contentW = content_course.clientWidth;
                let contentH = content_course.clientHeight;
                if (
                    firstImg &&
                    firstImg.className.indexOf('dragging') === -1 &&
                    that.state.drawRightTotal === 0 &&
                    subActionType &&
                    !(localSubActionType && localSubActionType === "1")
                ) {
                    let _left = newDarwObj[_id].defaultPos.x;
                    let _top = newDarwObj[_id].defaultPos.y;
                    let _x = item.detail.dstObjs[0].pos.x * contentW - _left;
                    let _y = item.detail.dstObjs[0].pos.y * contentH - _top;
                    let amiTime = 0;
                    let _time = 1000; //指引的总时间
                    let hand = document.createElement("IMG");
                    let ow = newDarwObj[_id].bigImageSize.width / 4;
                    let oh = newDarwObj[_id].bigImageSize.height / 4;
                    hand.src = window.publicUrl + "static/img/hand@2x.png";
                    hand.style.position = "absolute";
                    hand.style.width = "65px";
                    hand.style.height = "67px";
                    hand.style.left = _left + ow + "px";
                    hand.style.top = _top + oh + "px";
                    hand.style.zIndex = 997;
                    firstImg.parentNode.appendChild(hand);
                    firstImg.style.zIndex = 1;
                    let amiInterval = setInterval(() => {
                        firstImg.style.width = newDarwObj[_id].bigImageSize.width / 2 + "px";
                        firstImg.style.height = newDarwObj[_id].bigImageSize.height / 2 + "px";
                        firstImg.style.transform = `translate(${_left +
                            _x * (amiTime / _time)}px, ${_top +
                            _y * (amiTime / _time)}px)`;
                        hand.style.transform = `translate(${_left +
                            _x * (amiTime / _time) +
                            ow}px, ${_top + _y * (amiTime / _time) + oh}px)`;
                        hand.style.left = 0;
                        hand.style.top = 0;
                        if (amiTime >= _time) {
                            clearInterval(amiInterval);
                            setTimeout(() => {
                                firstImg.style.transform = `translate(${_left}px, ${_top}px)`;
                                firstImg.style.width = newDarwObj[_id].defaultWidth.width + "px";
                                firstImg.style.height = newDarwObj[_id].defaultWidth.height + "px";
                                firstImg.style.zIndex = 0;
                                if (hand && hand.parentNode) {
                                    hand.parentNode.removeChild(hand);
                                }
                                window.localStorage.setItem(subActionType, "1");
                            }, 200);
                        }
                        amiTime += 100;
                    }, 100);
                }
            }, 6000);
        }
        that.startWorkTime = new Date().getTime();
    }

    componentWillUnmount() {
        clearInterval(this.doneIntervalTimer);
        clearTimeout(this.guideTimer);
        clearTimeout(this.doneGuideTimer);
    }

    handleChangeSelect(drawRightTotal, dragState, index, gameDst, left, top, startMoveTime) {
        //dragState=2：正确；dragState=0：错误；dragState=3：在错误的位置落下；index-拖对位置的编号
        const that = this;
        const { item } = this.props;
        const { autoDisTipsDraw, dragAnswers, dragAnswerDsts, canMatch } = this.state;
        const feedbacks = item.detail.feedbacks;
        const matchAudio = document.getElementById("matchAudio");

        //拖对的音效
        if (dragState === 2 || (that.isDone && dragState > 1)) {    //拖对了 || done只要拖上去了就播对的音效
            let aUrl = window.resourceUrl + "audio/" + feedbacks.hit.audio.resourceID;
            matchAudio.setAttribute("src", aUrl);
            clearTimeout(that.guideTimer);
        } else if (canMatch) {
            let aUrl = window.resourceUrl + "audio/" + feedbacks.nohit.audio.resourceID;
            matchAudio.setAttribute("src", aUrl);
        }

        dragAnswers[index] = dragState === 2 || gameDst.indexOf("noDst") > -1 ? 1 : (dragState === 3 ? 0 : -1);
        dragAnswerDsts[index] = dragState === 0 ? "" : gameDst;

        that.setState({
            drawRightTotal: drawRightTotal,
            dragAnswers: dragAnswers,
            dragAnswerDsts: dragAnswerDsts,
            drawTotal: Utils.countItemInArray(dragAnswers, 0) + Utils.countItemInArray(dragAnswers, 1)
        }, () => {
            // console.log(that.state.dragAnswers, that.state.dragAnswerDsts)
            if (dragState === 2 || dragState === 3) {
                //添加点击选择的逻辑
                if (gameDst.includes(autoDisTipsDraw)) {
                    let doneStartKey = 0;
                    let curKey = that.curDrawRightArr.indexOf(autoDisTipsDraw);
                    // let nextKey = that.curDrawRightArr[index] === autoDisTipsDraw ? that.curDrawRightArr.indexOf(autoDisTipsDraw) + 1 : curKey;  //拖对的是当前默认选择的，就选择下一项 ： 否则还是选中当前
                    let nextKey = curKey;
                    if (nextKey >= item.detail.dstObjs.length - 1) {
                        nextKey = doneStartKey;
                    } else if (gameDst === autoDisTipsDraw) {
                        nextKey = that.curDrawRightArr.indexOf(autoDisTipsDraw) + 1;
                    }
                    let nextAutoDisTipsDraw = that.curDrawRightArr[nextKey];
                    let isInDrawRightArr = nextDraw => {
                        if (that.state.drawRightTotal >= item.detail.dstObjs.length || doneStartKey > item.detail.dstObjs.length) {
                            return "";
                        } else if (nextDraw && dragAnswerDsts.includes(nextDraw)) {
                            return isInDrawRightArr(that.curDrawRightArr[that.curDrawRightArr.indexOf(nextDraw) + 1]);
                        } else {
                            if (that.isDone && !nextDraw) {
                                doneStartKey++;
                                return isInDrawRightArr(that.curDrawRightArr[doneStartKey]);
                            } else {
                                return nextDraw;
                            }
                        }
                    };
                    that.setState({
                        autoDisTipsDraw: isInDrawRightArr(nextAutoDisTipsDraw)
                    });
                }

                that.curDrawRightNum = index;
            } else if (that.isDone && gameDst && dragState === 0 && !autoDisTipsDraw) {
                that.setState({
                    autoDisTipsDraw: gameDst   //gameDst
                });
                that.curDrawRightNum = index;
            } else {
                that.curDrawRightNum = -1;
            }

            if (that.isDone) {
                let doneBtn = document.getElementById('doneBtn');
                if (doneBtn && that.state.drawTotal === item.detail.dstObjs.length) {
                    that.doneIntervalTimer = setInterval(() => {
                        doneBtn.className = "dd done-btn";
                    }, 5000);
                    doneBtn.addEventListener("webkitAnimationEnd", function () {
                        doneBtn.className = "done-btn";
                    });

                    //用户指引
                    that.doneGuideTimer = setTimeout(() => {
                        let localClickDone = window.localStorage.getItem('clickDone');
                        if (!(localClickDone && localClickDone === "1")) {
                            let hand = document.createElement("IMG");
                            hand.src = window.publicUrl + "static/img/hand@2x.png";
                            hand.style.position = "absolute";
                            hand.style.width = "65px";
                            hand.style.height = "67px";
                            hand.style.left = "50px";
                            hand.style.top = "20px";
                            hand.style.zIndex = 997;
                            hand.className = "scale";
                            doneBtn.appendChild(hand);
                            window.localStorage.setItem("clickDone", "1");
                            setTimeout(() => {
                                doneBtn.removeChild(hand);
                            }, 2000);
                        }
                    }, 6000);
                } else {
                    clearInterval(that.doneIntervalTimer);
                }
            }

            //录屏相关代码
            if (window.needRecoRecordCourse) {
                ReplayAction.add(window.keyStr, that.isDone ? "MATCH_DONE_REPLAY_MOVE" : "MATCH_REPLAY_MOVE", startMoveTime - window.recordPageTime,
                    JSON.stringify({
                        rect: item.detail.dstObjs[index],
                        end_center_pos: {
                            x: left,
                            y: top
                        },
                        matchType: dragState === 2 ? "succ" : "fail",
                        src: item.detail.srcObjs[index]
                    })
                );
                that.replayKeyNum++;
            }
        });
    }

    handleComplate(feedback) {
        const that = this;
        const { item, childCallback } = this.props;
        const { currStarCount, currSubjectCount, retryTimes } = this.state;
        const judgeFunction = item.detail.judgeFunction;
        const timeout = item.detail && item.detail.feedbacks && item.detail.feedbacks.timeout ? item.detail.feedbacks.timeout : null;
        let type = "";
        let info = "";
        that.setState({
            canMatch: false
        });
        if (feedback) {
            if (feedback.type) {
                type = feedback.type;
            }
            if (feedback.info) {
                info = feedback.info;
            }
        } else {
            if (that.isDone) {
                that.handleSubmitDone();
                return;
            } else {
                type = timeout ? timeout.type : "";
                info = timeout ? timeout.info : "";
            }
        }
        if (judgeFunction) {
            let returnScore = JSON.parse(
                window[judgeFunction](
                    item.actionID,
                    type,
                    info,
                    currStarCount,
                    currSubjectCount,
                    retryTimes,
                )
            );

            if (returnScore && returnScore.resultInfo && returnScore.timeline) {
                if (typeof childCallback === "function") {
                    //录屏相关代码
                    if (window.needRecoRecordCourse) {
                        ReplayAction.add(window.keyStr, that.isDone ? "MATCH_DONE_REPLAY_FEEDBACK" : "MATCH_REPLAY_FEEDBACK", new Date().getTime() - window.recordPageTime,
                            JSON.stringify(returnScore)
                        );
                        ReplayAction.commit(window.keyStr, item.actionType);
                        window.keyStr += `.detail.timeline.nodes[${that.replayKeyNum}].actions[0]`;

                        childCallback(returnScore, ReplayAction.getScene());

                        ReplayAction.cleanScene();
                    } else {
                        childCallback(returnScore);
                    }
                }
            }
        }

        //上报学习报告
        if (that.cid) {
            // Utils.reportRecord(window.startTime, item.actionID, item.actionType, type, 0, item.knowledge);

            if (item.actionID === window.actionID) {
                that.roundNum++;
            } else {
                that.roundNum = 1;
            }
            window.actionID = item.actionID;
            Utils.newReportRecord({
                "cid": that.cid,
                "startTime": window.startTime,
                "actionId": item.actionID,
                "actionType": item.actionType,
                "fbType": type,   //fbType,
                "roundNum": that.roundNum,  //轮数（第几轮回答，默认第一轮：1）
                "score": 0,
                "pageNum": window.curPageToReport || 0,
            }, {
                "knowledge": item.knowledge
            });

            // 给积分
            Utils.giveIntegrals(that.isDone ? 1 : 2, {
                totalTime: timeout ? timeout.time : 60,
                useTime: (new Date().getTime() - that.startWorkTime) / 1000,
                roundNum: that.roundNum,
                fbType: type
            });

            // 勋章上报
            Utils.encourageRecord({
                "cid": that.cid,
                "startTime": window.startTime,
                "actionId": item.actionID,
                "actionType": item.actionType,
                "fbType": type,   //fbType,
                "roundNum": that.roundNum,  //轮数（第几轮回答，默认第一轮：1）
                "score": 0,
                "pageNum": window.curPageToReport || 0,
                "integrals": window.curIntegrals,
            });
        }
    }

    //点击done提交结果
    handleSubmitDone() {
        const that = this;
        const { item } = this.props;
        const { drawRightTotal } = this.state;
        const feedbacks = item.detail.feedbacks;
        const restoreOption = item.detail.restoreOption || 0;   //1-错误弹回；2-全部弹回
        clearInterval(that.doneIntervalTimer);
        clearTimeout(that.doneGuideTimer);
        if (drawRightTotal === item.detail.dstObjs.length) {
            setTimeout(() => {
                !that.isOver && that.handleComplate(feedbacks.succ);
            }, 500);
        } else {
            //做弹回、弹对逻辑
            !that.isOver && that.handleComplate(feedbacks.fail);
            that.setState({
                restoreOption: restoreOption
            });
        }
    }

    //处理 AudioMutiMatchGameInteraction_ 音频播放完成
    handleEndedAudio() {
        const that = this;
        const { item } = this.props;
        const { drawRightTotal, playNum } = this.state;
        const feedbacks = item.detail.feedbacks;

        //拖对的个数等于正确的总数
        const complateBack = function () {
            if (drawRightTotal === item.detail.dstObjs.length) {
                setTimeout(() => {
                    !that.isOver && that.handleComplate(feedbacks.succ);
                }, 500);
            }
        };

        if (item.actionType === "AudioMutiMatchGameInteraction_" && that.autoPlayList.length) {
            //先移除之前添加的json动画
            // const targetEle = document.getElementById(that.autoPlayList[playNum].id);
            const audioAnimation = document.getElementById("audioAnimation");
            if (audioAnimation && audioAnimation.parentNode) {
                audioAnimation.parentNode.removeChild(audioAnimation);
            }

            // if (that.curDrawRightNum > -1) { //拖对了开始播放音频
            //     that.playAudio(that.curDrawRightNum);
            //     that.curDrawRightNum = -1;
            // } else
            if (drawRightTotal === 0) {
                //还没有拖对的，走自动播放流程
                if (playNum < that.autoPlayList.length) {
                    that.setState({
                        playNum: playNum + 1
                    }, () => {
                        if (that.state.playNum < that.autoPlayList.length) {
                            that.playAudio(that.state.playNum);
                        }
                    });
                }
            } else {
                complateBack();
            }
        } else if (item.actionType === "MutiMatchGameInteraction_") {
            complateBack();
        }
    }

    playAudio(num, flag) {
        //flag-true 不需要延时
        const that = this;
        setTimeout(() => {
            //播放音频
            const matchAudio = document.getElementById("matchAudio");
            const curPlayAudio = that.autoPlayList[num];

            if (matchAudio && curPlayAudio) {
                matchAudio.setAttribute("src", window.resourceUrl + "audio/" + curPlayAudio.audio);

                //添加播放动画
                const targetEle = document.getElementById(curPlayAudio.id);
                if (targetEle) {
                    const oldAudioAnimation = document.getElementById("audioAnimation");
                    if (oldAudioAnimation && oldAudioAnimation.parentNode) {
                        oldAudioAnimation.parentNode.removeChild(oldAudioAnimation);
                    }
                    const audioAnimation = document.createElement("div");
                    audioAnimation.setAttribute("id", "audioAnimation");
                    audioAnimation.style.position = "absolute";
                    audioAnimation.style.top = targetEle.style.top;
                    audioAnimation.style.left = targetEle.style.left;
                    audioAnimation.style.width = targetEle.style.width;
                    audioAnimation.style.height = targetEle.style.height;
                    targetEle.parentNode.insertBefore(audioAnimation, targetEle);
                    lottie.loadAnimation({
                        container: audioAnimation,
                        renderer: "canvas",
                        loop: true,
                        autoplay: true,
                        path: window.animationUrl + "match_data.json"
                    });
                }
            }
        }, flag ? 0 : 800);
    }

    handlePlayError() {
        let playFun = () => {
            const matchAudio = document.getElementById('matchAudio');
            if (matchAudio) {
                let playPromise = matchAudio.play();
                if (playPromise !== undefined) {
                    playPromise.then(_ => {

                    })
                        .catch(error => {
                            // utils.showTips("播放失败，点击这里继续", -1, () => {
                            //     playFun();
                            // });
                        });
                }
            }
        };
        utils.showTips("播放失败，点击这里继续", -1, () => {
            playFun();
        });
    }

    render() {
        const that = this;
        const { item } = this.props;
        const {
            darwObj,
            drawRightTotal,
            autoDisTipsDraw,
            canMatch,
            matchDoneElements,
            dragAnswers,
            dragAnswerDsts,
            drawTotal,
            restoreOption
        } = this.state;
        return (
            <div id="MatchGame" className="match-game">
                {/*drawRightTotal !== item.detail.dstObjs.length && */item.detail.feedbacks && canMatch ? (
                    <CountdownTimer feedbacks={item.detail.feedbacks} complateCallback={that.handleComplate.bind(that)} />
                ) : null}

                {
                    canMatch && that.isDone && (drawTotal === item.detail.dstObjs.length) && item.detail.doneButton ?
                        <div id="doneBtn" className="done-btn" style={{
                            "top": item.detail.doneButton.pos.y * 100 + "%",
                            "left": item.detail.doneButton.pos.x * 100 + "%",
                            "width": item.detail.doneButton.size.width / 2 + "px",
                            "height": item.detail.doneButton.size.height / 2 + "px",
                            "lineHeight": item.detail.doneButton.size.height / 2 + "px",
                        }} onClick={() => that.handleSubmitDone()}>Done</div>
                        : null
                }

                {darwObj && Object.keys(darwObj).map((key, index) => {
                    let darwItem = darwObj[key];
                    return (
                        <div key={index}>
                            {/* {
                                    darwItem.matchPos ?
                                        <div style={{
                                            "background": "rgba(0,0,0,0.5)",
                                            "position": "absolute",
                                            "top": darwItem.matchPos[0].y * 100 + "%",
                                            "left": darwItem.matchPos[0].x * 100 + "%",
                                            "width": darwItem.matchSize.width / 2 + "px",
                                            "height": darwItem.matchSize.height / 2 + "px",
                                        }} />
                                        : null
                                } */}
                            {darwItem.pos &&
                                item.detail.dstObjs[index].id === autoDisTipsDraw && item.detail.dstObjs.length > 1 && canMatch ?
                                <div title="可点击正确答案自动填入"
                                    style={{
                                        position: "absolute",
                                        top: item.detail.dstObjs[index].pos.y * 100 + "%",
                                        left: item.detail.dstObjs[index].pos.x * 100 + "%",
                                        width: darwItem.bigImageSize.width / 2 + "px",
                                        height: darwItem.bigImageSize.height / 2 + "px",
                                        background: "rgba(9,197,7,.1)",
                                        border: "2px solid rgba(9,197,7,1)"
                                        // "boxShadow": "0 0 10px rgba(9,197,7,1)",
                                        // "borderRadius": darwItem.bigImageSize.height <= 100 ? darwItem.bigImageSize.height / 2 + "px" : 0,
                                    }}
                                />
                                : null}
                            <MatchDraw
                                index={index}
                                item={darwItem}
                                drawRightTotal={drawRightTotal}
                                total={item.detail.dstObjs.length}
                                autoDisTipsDraw={autoDisTipsDraw}
                                canMatch={canMatch}
                                changeSelect={that.handleChangeSelect.bind(that)}
                                isDone={that.isDone}
                                matchDoneElements={matchDoneElements}
                                dragAnswers={dragAnswers}
                                dragAnswerDsts={dragAnswerDsts}
                                restoreOption={restoreOption}
                            />
                        </div>
                    );
                })}
                <audio id="matchAudio" src="https://webres.putaoabc.com/course/mp3/none.mp3" autoPlay onEnded={() => that.handleEndedAudio()} onError={() => { that.handlePlayError() }} />
            </div>
        );
    }
}

export default MatchGame;



// WEBPACK FOOTER //
// ./src/components/on/MatchGame.js